import React, { useState } from 'react';
import { FaGlobe, FaCheck } from 'react-icons/fa';

const LanguageSelector = ({ language, changeLanguage }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleLanguageChange = (lang) => {
        changeLanguage(lang);
        setIsOpen(false);
    };

    // Close dropdown when clicking outside
    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.language-selector')) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="language-selector">
            <button className="language-btn" onClick={toggleDropdown}>
                <FaGlobe />
            </button>
            <div className={`language-options ${isOpen ? 'show' : ''}`}>
                <div
                    className="language-option"
                    onClick={() => handleLanguageChange('en')}
                >
                    <FaCheck style={{ display: language === 'en' ? 'inline-block' : 'none' }} /> English
                </div>
                <div
                    className="language-option"
                    onClick={() => handleLanguageChange('zh')}
                >
                    <FaCheck style={{ display: language === 'zh' ? 'inline-block' : 'none' }} /> 中文 (Chinese)
                </div>
            </div>
        </div>
    );
};

export default LanguageSelector;
